<template>
  <div class="error-page">
    <section class="error-page-content">
      <div class="logo-wrapper">
        <img class="logo" v-if="brandingInfo" :src="brandingInfo.logoLarge.url" :alt="brandingInfo.logoLarge.alt" />
      </div>
      <h1 class="visually-hidden">404 - {{ `${t('notFound.titleFirstPart')} ${t('notFound.titleSecondPart')}` }}</h1>
      <h2 class="error-page-title first-part" aria-hidden="true">
        404 °N <br />
        {{ t('notFound.titleFirstPart') }}
      </h2>
      <img class="error-page-image" src="/statics/images/error-page-fg.png" :alt="t('notFound.foregroundImageAlt')" />
      <div class="error-page-description">
        <h2 class="error-page-title second-part" aria-hidden="true">{{ t('notFound.titleSecondPart') }}</h2>
        <p class="error-page-text">
          {{ t('notFound.text') }}
        </p>
        <IconButton icon-name="earth" :to="{ name: mapRouteName }" transparent arrow>{{
          t('notFound.linkText')
        }}</IconButton>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

import IconButton from '@/components/common/IconButton.vue';
import { useBranding } from '@/composables/use-branding';
import { getRouteName, Route } from '@/router';

export default defineComponent({
  components: {
    IconButton,
  },
  setup() {
    const { brandingInfo } = useBranding();
    const { t } = useI18n();
    const mapRouteName = getRouteName(Route.Map);

    return {
      brandingInfo,
      t,
      mapRouteName,
    };
  },
});
</script>
